import { combineReducers } from 'redux';
import { createGenericRequestStatusReducer } from 'ContentData/helpers/reduxHelpers';
import { SALESFORCE_CLEAR_CAMPAIGNS, SALESFORCE_SAVE_CAMPAIGN_CACHE, SALESFORCE_FETCH_CAMPAIGN, SALESFORCE_FETCH_CAMPAIGNS, SALESFORCE_FETCH_INTEGRATION_STATUS } from 'ContentData/actions/ActionTypes';
const campaigns = (state = {}, action) => {
  switch (action.type) {
    case SALESFORCE_FETCH_CAMPAIGN:
      {
        const {
          response
        } = action;
        if (!response) return state;
        return Object.assign({}, state, {
          [response.id]: response
        });
      }
    case SALESFORCE_SAVE_CAMPAIGN_CACHE:
      {
        const {
          campaign
        } = action;
        if (!campaign) return state;
        return Object.assign({}, state, {
          [campaign.id]: campaign
        });
      }
    default:
      return state;
  }
};
const campaignsCache = (state = {}, action) => {
  switch (action.type) {
    case SALESFORCE_FETCH_CAMPAIGNS:
      {
        const {
          response
        } = action;
        if (!response) return state;
        return response.results.reduce((hash, campaign) => {
          hash[campaign.id] = campaign;
          return hash;
        }, Object.assign({}, state));
      }
    case SALESFORCE_CLEAR_CAMPAIGNS:
      {
        if (Object.keys(state).length) return {};
        return state;
      }
    default:
      return state;
  }
};
const integrationStatus = (state = null, action) => {
  switch (action.type) {
    case SALESFORCE_FETCH_INTEGRATION_STATUS:
      {
        const {
          response
        } = action;
        if (response) return response.integrationStatus;
        return state;
      }
    default:
      return state;
  }
};
export default combineReducers({
  campaigns,
  campaignsCache,
  campaignsRequestStatus: createGenericRequestStatusReducer(SALESFORCE_FETCH_CAMPAIGN),
  campaignsCacheRequestStatus: createGenericRequestStatusReducer(SALESFORCE_FETCH_CAMPAIGNS),
  integrationStatus
});